module.exports = __webpack_public_path__ + "static/media/steve-bass-face.15da2979.jpg";